import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21691ef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Size yöneltmiş olduğumuz sorulara verdiğiniz cevaplardan yola çıkarak tespitlerimiz aşağıdaki şekildedir:", -1))
const _hoisted_3 = { class: "list-disc ml-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_benchmark_table = _resolveComponent("benchmark-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", {
      class: _normalizeClass(["break-after-avoid-page", $props.titleClass])
    }, _toDisplayString($props.title), 3),
    _createElementVNode("p", { innerHTML: $props.description }, null, 8, _hoisted_1),
    _createVNode(_component_benchmark_table, {
      benchmark: $props.benchmarkResult,
      score: $props.scoreResult,
      title: $props.tableTitle
    }, null, 8, ["benchmark", "score", "title"]),
    ($props.detectionList.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.detectionList, (detection, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(detection), 1))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}